import React from 'react';
import {
    TextField,
    Autocomplete,
    IconButton,
    FormControlLabel,
    Switch,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

export const SearchAndFilters = ({
    filters,
    filterOptions,
}) => {
    const handleSearchChange = (event) => {
        filters.setSearch(event.target.value);
    };

    const clearSearch = () => {
        filters.setSearch('');
    };

    return (
        <div className="search-box">
            <TextField
                className="dense-field"
                label="Game Name / Module ID / Launch ID"
                value={filters.search}
                onChange={handleSearchChange}
                variant="outlined"
                InputProps={{
                    endAdornment: filters.search ? (
                        <IconButton onClick={clearSearch}>
                            <ClearIcon />
                        </IconButton>
                    ) : null,
                }}
            />
            <Autocomplete
                options={filterOptions.platformList}
                getOptionLabel={(option) => option}
                value={filters.platform}
                onChange={(event, newValue) => filters.setPlatform(newValue)}
                renderInput={(params) => <TextField {...params} label="Platform" variant="outlined" />}
            />
            <Autocomplete
                options={filterOptions.providerList}
                getOptionLabel={(option) => option}
                value={filters.provider}
                onChange={(event, newValue) => filters.setProvider(newValue)}
                renderInput={(params) => <TextField {...params} label="Provider" variant="outlined" />}
            />
            <FormControlLabel
                control={
                    <Switch
                        checked={filters.gameflexOnly}
                        onChange={(e) => filters.setGameflexOnly(e.target.checked)}
                    />
                }
                label="Gameflex"
            />
        </div>
    );
};